import apiClient from './api';

export interface BlockedDateEntry {
  availabilityId: string;
  consultationType: string;
  startDate: string;
  endDate: string;
  startTime: string;
  endTime: string;
  createdAt: string;
}

export interface GetBlockedDatesResponse {
  consultationType: string;
  blockedDates: BlockedDateEntry[];
}

export interface AddBlockedDatePayload {
  consultationType: string;
  startDate: string;
  endDate: string;
  startTime: string;
  endTime: string;
}

export const consultationService = {
  getBlockedDates: async (consultationType: string): Promise<BlockedDateEntry[]> => {
    const response = await apiClient.get('/consultation/blocked-dates', {
      params: { consultationType }
    });
    return response.data?.data?.blockedDates || [];
  },

  addBlockedDate: async (payload: AddBlockedDatePayload): Promise<BlockedDateEntry> => {
    const response = await apiClient.post<BlockedDateEntry>('/consultation/blocked-dates', payload);
    return response.data;
  },

  removeBlockedDate: async (availabilityId: string, consultationType: string): Promise<void> => {
    await apiClient.delete(`/consultation/blocked-dates/${availabilityId}`, {
      data: { consultationType }
    });
  }
};
